export const MINIMUM_HOURS_BEFORE_BOOKING_ALLOWED = 2;
export const FRANCHISE_MINIMUM_HOURS_BEFORE_BOOKING_ALLOWED = 0;
